import React, { useCallback, useEffect, useState } from "react";
import { useApi } from "../../hooks/api";
import { FiDownload, FiPrinter } from "react-icons/fi";
import { useGlobal } from "../../hooks/global";
import { IoNotifications } from "react-icons/io5";
import { TbRotateClockwise } from "react-icons/tb";
import { ITable } from "../../components/TableList";
import { PageList, PageListRef } from "../../components/PageList";
import { info, secondary } from "../../theme";
import { getFilterFields } from "../../utils/filterFields";
import { FaBook, FaEdit, FaWhatsapp } from "react-icons/fa";
import { IPermissionsTypes } from "../../utils/permissions";
import { ModalSendWpp } from "../../components/Modals/ModalSendWpp";
import { reservation_status } from "../../utils/reservation_status";
import { ModalLoading } from "../../components/Loadings/ModalLoading";
import { ModalSendEmail } from "../../components/Modals/ModalSendEmail";
import { ModalReservations } from "../../components/Modals/ModalReservations/index";
import { IStaysReservationProps, IActions, IFilters } from "../../interfaces/index";
import { correctDate, correctDateDashboard, setUpConsultation } from "../../services/generalServices";
import { ModalReservationsNotifications } from "../../components/Modals/ModalReservationsNotifications";
import { getCheckStatus, getGuestWithAdicionalGuestsBadge, getOrigin, getStatus } from "../../utils/columnsTables";
import { CgBlock, CgCheckO, CgDanger } from "react-icons/cg";
import { checkInStatusOptions, get_corrrect_names, reservationStatusOptions } from "../../utils/options";
import { MdDelete, MdOutlineEmail } from "react-icons/md";
import { useWallet } from "../../hooks/wallet";
import { LiaFileContractSolid } from "react-icons/lia";
import { ModalExportGuests } from "../../components/Modals/ModalExportGuests";

export const checkInStatusMapper: { [key: string]: { text: string; color: string, icon: React.ReactElement<any> } } = {
  pending: { text: "Pendente", color: '#FAAD14', icon: <CgDanger size={19} style={{ marginRight: 3 }} /> },
  done: { text: "Realizado", color: '#52C41A', icon: <CgCheckO size={16} style={{ marginRight: 3 }} /> },
  late: { text: "Em atraso", color: '#FF6B6B', icon: <CgBlock size={19} style={{ marginRight: 3 }} /> },
  not_realized: { text: "Não realizado", color: '#FF6B6B', icon: <CgBlock size={16} style={{ marginRight: 3 }} /> },
}

const initialFilters: IFilters[] = [
  getFilterFields("order_by"),
  getFilterFields("reservation_status"),
  getFilterFields("check_in_status"),
  getFilterFields("check_out_status"),
  getFilterFields("check_in"),
  getFilterFields("check_out"),
  getFilterFields("created_at"),
];

const initialTable: ITable = {
  data: [],
  columns: [
    {
      attr: "origin",
      name: "Origem",
      style: { textAlign: "center" },
      styleContent: { fontSize: 14, textAlign: "center" },
    },
    {
      attr: "stays_id",
      name: "ID",
      style: { textAlign: "center" },
      styleContent: { fontSize: 16, fontWeight: 600, textAlign: "center" },
    },
    {
      attr: "guest_accommodation",
      name: "Hóspede / Acomodação",
      style: {},
      styleContent: { fontSize: 16, display: 'flex', flex: 1 },
    },
    {
      attr: "reservation_status",
      name: "Status da Reserva",
      style: { textAlign: "center" },
      styleContent: { fontSize: 14 },
    },
    {
      attr: "checkIn",
      name: "Entrada",
      style: { textAlign: "center" },
      styleContent: { fontSize: 14, textAlign: "center" },
    },
    {
      attr: "checkOut",
      name: "Saída",
      style: { textAlign: "center" },
      styleContent: { fontSize: 14, textAlign: "center" },
    },
    {
      attr: "check_in_status",
      name: "Status do Check-in",
      style: { textAlign: "center" },
      styleContent: { fontSize: 14 },
    },
    {
      attr: "check_out_status",
      name: "Checkout",
      style: { textAlign: "center" },
      styleContent: { fontSize: 14 },
    },
    {
      attr: "createdAt",
      name: "Criado em",
      style: { textAlign: "center" },
      styleContent: { fontSize: 14, textAlign: "center" },
    },
  ],
};

export const propertyInExtension = (address: any) => {
  if (!address) return "-";
  return `${address?.street}, ${address?.region}, Nº ${address?.streetNumber}, ${address?.city} - ${address?.stateCode}`;
};

const getCorrectCreatedAt = (createdAt: any) => {
  const correctCreatedAt = new Date(createdAt)
  correctCreatedAt.setHours(correctCreatedAt.getHours() + 3)
  return correctDate(correctCreatedAt, { no_have_time: true })
}

export const ReservationsList: React.FC = () => {
  const { user, api } = useApi();
  const { theme, paginationLimit, notify, business } = useGlobal();
  const { subscription } = useWallet();

  const [loading, setLoading] = useState(false);
  const [atualPage, setAtualPage] = useState(1);
  const [filters, setFilters] = useState<any>({});
  const [openModal, setOpenModal] = useState(false);
  const [openModalNotification, setOpenModalNotifications] = useState(false);
  const [numOfReservations, setNumOfReservations] = useState(0);
  const [updatedAt, setUpdatedAt] = useState(new Date());
  const [loadingReservations, setLoadingReservations] = useState(true);
  const [searchString, setSearchString] = useState<string>("");
  const [numberOfPages, setNumberOfPages] = useState<number>(1);
  const [reservationSelected, setReservationSelected] = useState<IStaysReservationProps | null>(null);
  const [table, setTable] = useState<ITable>(initialTable);
  const [selectedCheckInSendEmail, setSelectedCheckInSendEmail] = useState<IStaysReservationProps | null>(null);
  const [selectedCheckInSendWpp, setSelectedCheckInSendWpp] = useState<IStaysReservationProps | null>(null);
  const [openModalExportGuests, setOpenModalExportGuests] = useState(false);
  const page_ref = React.useRef<PageListRef>(null);

  const isHaveGuestPdfPermission = subscription?.plans?.permissions.includes("GUEST_RECORD");
  const isHaveAcessInstructionsPermission = subscription?.plans?.permissions.includes("ACCESS_INSTRUCTIONS");

  const selectReservation = useCallback(
    (accomoddation: IStaysReservationProps) => {
      setReservationSelected({ ...accomoddation });
      setOpenModal(true);
    },
    []
  );

  const handleOpenModalNotification = useCallback(
    (accomoddation: IStaysReservationProps) => {
      setReservationSelected({ ...accomoddation });
      setOpenModalNotifications(true);
    },
    []
  );

  const searchReservations = useCallback(
    async (page, _filters = null) => {
      setAtualPage(page);
      setLoadingReservations(true);
      try {
        const filters_obj = _filters ? _filters : { ...filters, search: searchString };

        let string = setUpConsultation(filters_obj);
        let url = `/stays-reservations?page=${page}&limit=${paginationLimit}&${string}`;

        const result = await api.get(url);
        const new_reservations = result.data.data as IStaysReservationProps[];
        setTable((atual) => {
          const new_table = { ...atual };

          new_table.data = [];
          new_reservations.forEach((reservation) => {
            const checkInDate = String(reservation.check_in_date).split("T")[0];
            const checkInTime = String(reservation.check_in_time);
            const checkIn = correctDateDashboard(
              new Date(checkInDate + " " + checkInTime)
            );

            const checkOutDate = String(reservation.check_out_date).split(
              "T"
            )[0];
            const checkOutTime = String(reservation.check_out_time);
            const checkOut = correctDateDashboard(
              new Date(checkOutDate + " " + checkOutTime)
            );

            const checkInRealizedDate = String(reservation.correct_realized_check_in)?.split("T")[0];
            const checkInRealizedTime = String(reservation.correct_realized_check_in)?.split("T")[1]?.split(":").slice(0, 2).join(":");
            const checkInRealized = checkInRealizedDate !== 'null' ?
              correctDateDashboard(new Date(checkInRealizedDate + " " + checkInRealizedTime))
              : null;

            const checkOutRealizedDate = String(reservation.correct_realized_check_out)?.split("T")[0];
            const checkOutRealizedTime = String(reservation.correct_realized_check_out)?.split("T")[1]?.split(":").slice(0, 2).join(":");
            const checkOutRealized = checkOutRealizedDate !== 'null' ?
              correctDateDashboard(new Date(checkOutRealizedDate + " " + checkOutRealizedTime))
              : null;

            const guestPrimary = getGuestWithAdicionalGuestsBadge({ guests: reservation?.guests, accommodation_stays_id: reservation?.accommodation_stays_id_code, theme });

            new_table.data.push({
              stays_id: reservation.stays_id,
              id: reservation.id,
              guests: guestPrimary,
              guest_accommodation: guestPrimary,
              reservation_status: getStatus({
                ...reservation_status[reservation.reservation_status],
                theme,
              }),
              check_in_status: getCheckStatus({
                theme,
                dateSrt: checkInRealized,
                ...checkInStatusMapper[reservation.check_in_status],
              }),
              check_out_status: getCheckStatus({
                theme,
                dateSrt: checkOutRealized,
                text: reservation?.check_out?.id ? "Confirmado" : "Não confirmado",
                color: reservation?.check_out?.id ? '#52C41A' : info,
                icon: reservation?.check_out?.id ? <CgCheckO size={16} style={{ marginRight: 3 }} /> : <CgDanger size={16} style={{ marginRight: 3 }} />,
              }),
              checkIn,
              checkOut,
              origin: getOrigin({ origin: reservation.origin, theme }),
              createdAt: getCorrectCreatedAt(reservation.createdAt),
              this: reservation,
            });
          });

          return { ...new_table };
        });
        setNumOfReservations(result.data.count);
        setNumberOfPages(Math.ceil(result.data.count / paginationLimit));
        setUpdatedAt(new Date());
      } catch (err) {
        notify("Erro na busca pelas reservas!", "error");
      }
      setLoadingReservations(false);
    },
    [user, filters, searchString]
  );

  const openModalNewReservation = useCallback(() => {
    setReservationSelected(null);
    setOpenModal(true);
  }, []);

  const handleAction = (action_id: string) => {
    if (action_id === "new_item") openModalNewReservation();
    if (action_id === "export_guests") setOpenModalExportGuests(true);
  };

  const actionsInitial: IActions[] = [
    {
      main_option: { text: "Exportar hóspedes", id: "export_guests" },
      className: "export_guests",
      icon: <FiDownload size={20} className="export_guests" />,
      options: [],
      type: "solid",
      permissions: ["STAYS-RESERVATIONS-LIST"],
    },
  ];

  const handleRecreateCheckIn = useCallback(
    async (id: string) => {
      setLoading(true);

      try {
        await api.post(`/check-ins/create-new-password/${id}`);
        notify("Check-in recriado com sucesso!", "success");
        searchReservations(1);
      } catch (error: any) {
        notify("Erro ao recriar o check-in!", "error");
      }

      setLoading(false);
    },
    [api]
  );

  const handleUpdateReservation = useCallback(async (id: string) => {
    setLoading(true)

    try {
      await api.post(`/stays-reservations/${id}`)
      notify("Reserva atualizada com sucesso!", "success")
      searchReservations(1);
    } catch (err) {
      notify("Erro ao atualizar a reserva!", "error")
    }

    setLoading(false)
  }, []);

  const confirmRecreateCheckIn = useCallback(
    async (item: any): Promise<void> => {
      const result = window.confirm(
        "Tem certeza que deseja recriar o check-in da reserva " +
        item?.stays_id
      );

      if (result) handleRecreateCheckIn(item.check_in_id as unknown as string);
    },
    [handleRecreateCheckIn]
  );

  const handleConfirmDeleteCheckIn = useCallback(
    async (id: string) => {
      setLoading(true);

      try {
        await api.delete(`/check-ins/${id}`);

        notify("Check-in excluído com sucesso!", "success");

        await searchReservations(1);
      } catch (error: any) {
        const default_message = "Erro ao excluir a check-in!";
        const message = error.response?.data?.detail ?? default_message;
        notify(message, message === default_message ? "error" : "alert");
      }

      setLoading(false);
    },
    [searchReservations]
  );

  const alertDelete = useCallback(
    async (item: any): Promise<void> => {

      const result = window.confirm(
        "Tem certeza que deseja excluir o check-in da reserva " +
        item?.stays_id
      );

      if (result) handleConfirmDeleteCheckIn(item.check_in_id as unknown as string);
    },
    [handleConfirmDeleteCheckIn]
  );

  const listAction = [
    {
      title: "Editar",
      onClick: (reservation: IStaysReservationProps) => selectReservation(reservation),
      icon: <FaEdit color={secondary[theme]} size={20} />,
      disabled: () => false,
    },
    {
      title: "Contrato",
      onClick: (item: any) => window.open(`/contract-reservation?reservation_id=${item.id}`, "_blank"),
      icon: <LiaFileContractSolid color={secondary[theme]} size={20} />,
      disabled: (item: any) => !item?.is_have_contract_model,
    },
    {
      title: "Notificações",
      onClick: (reservation: IStaysReservationProps) => handleOpenModalNotification(reservation),
      icon: <IoNotifications color={secondary[theme]} size={20} />,
      disabled: () => false,
    },
    {
      title: "Abrir reserva na Stays",
      onClick: (item: any) =>
        window.open(
          `${business?.stays_url}/i/reservation/${item?.stays_id}`,
          "_blank"
        ),
      icon: <FaBook color={secondary[theme]} size={20} />,
      disabled: () => false,
    },
    {
      title: "Atualizar reserva",
      onClick: (item: any) => handleUpdateReservation(item.id),
      icon: <TbRotateClockwise color={secondary[theme]} size={20} />,
      disabled: () => !user.user_type.permissions.includes('STAYS-RESERVATIONS-UPDATE'),
    },
    {
      title: "Recriar check-in",
      onClick: confirmRecreateCheckIn,
      icon: <TbRotateClockwise color={secondary[theme]} size={20} />,
      disabled: (item: any) => (
        !user.user_type.permissions.includes("STAYS-RESERVATIONS-UPDATE" as IPermissionsTypes)
        || !item?.check_in_id
      ),
    },
    {
      title: "Excluir check-in",
      onClick: (item: any) => alertDelete(item),
      icon: <MdDelete color={secondary[theme]} size={20} />,
      disabled: (item: any) => (
        !user.user_type.permissions.includes("STAYS-RESERVATIONS-CHECK-INS-DELETE" as IPermissionsTypes)
        || !item?.check_in_id
      ),
    },
  ];

  const beforeListAction = [
    {
      title: "Enviar email",
      onClick: (item: any) => setSelectedCheckInSendEmail(item),
      icon: <MdOutlineEmail color={secondary[theme]} size={20} />,
      disabled: () => !user.user_type.permissions.includes("SEND_EMAILS" as IPermissionsTypes) || !isHaveAcessInstructionsPermission,
    },
    {
      title: "Enviar WhatsApp",
      onClick: (item: any) => setSelectedCheckInSendWpp(item),
      icon: <FaWhatsapp color={secondary[theme]} size={20} />,
      disabled: () => !user.user_type.permissions.includes("SEND_WPP" as IPermissionsTypes) || !isHaveAcessInstructionsPermission,
    },
    {
      title: "Ficha dos hóspedes",
      onClick: (item: any) => window.open(`/guest-registration-pdf?reservation-id=${item.id}`, "_blank"),
      icon: <FiPrinter color={secondary[theme]} size={20} />,
      disabled: () => !isHaveGuestPdfPermission,
    }
  ];

  const onSaveReservation = useCallback(() => {
    setOpenModal(false);
    searchReservations(1);
  }, [user, filters, searchString]);

  useEffect(() => {
    const query = window.location.search.split("?").pop()
    const queries = query ? query.split("&") : [""]
    let status: any = queries.find((item: string) => item.split("=")[0] === "status")
    status = status ? status.split("=")[1] : null
    if (status) {
      setFilters({ check_in_status: status, reservation_status: 'booked' })

      page_ref.current?.setFilters((prev) => {
        const checkInStatusFilterIndex = prev.findIndex((filter) => filter.key === "check_in_status" as any)
        const reservationStatusFilterIndex = prev.findIndex((filter) => filter.key === "reservation_status" as any)

        if (checkInStatusFilterIndex !== -1) {
          const mapper = get_corrrect_names(checkInStatusOptions);

          prev[checkInStatusFilterIndex] = { ...prev[checkInStatusFilterIndex], value: { label: mapper[status], value: status } }
        }

        if (reservationStatusFilterIndex !== -1) {
          const mapper = get_corrrect_names(reservationStatusOptions);
          prev[reservationStatusFilterIndex] = { ...prev[reservationStatusFilterIndex], value: { label: mapper['booked'], value: 'booked' } }
        }

        return prev
      })

      searchReservations(1, { check_in_status: status, reservation_status: 'booked' })
    }
    else searchReservations(1)
  }, []);

  useEffect(() => {
    if (loadingReservations) return;

    const query = window.location.search.split("?").pop();

    const queries = query ? query.split("&") : [""];

    let status: any = queries.find((item: string) => item.split("=")[0] === "status");

    status = status ? status.split("=")[1] : null;

    if (status && !filters?.check_in_status) {
      window.history.replaceState({}, document.title, window.location.pathname)
    }
  }, [filters, loadingReservations]);

  return (
    <PageList
      updatedAt={updatedAt}
      loading={loadingReservations}
      setLoading={setLoadingReservations}
      numberOfItems={numOfReservations}
      actions={actionsInitial}
      onClickOption={handleAction}
      textHeader="Reservas"
      textItems="reservas encontradas"
      text_loading={"Buscando Reservas"}
      text_empty={"Nenhuma reserva encontrada"}
      moduleName="reservations"
      theme={theme}
      initialFilters={initialFilters}
      onChangeFilters={setFilters}
      table={table}
      pages={numberOfPages}
      page={atualPage}
      search={searchReservations}
      onChangeSearch={setSearchString}
      listActions={listAction}
      beforeListActions={beforeListAction}
      ref={page_ref}
    >
      {openModal && (
        <ModalReservations
          onCancel={() => setOpenModal(false)}
          onSave={onSaveReservation}
          openModal={openModal}
          backgroundVisible={false}
          defaultId={reservationSelected?.id}
        />
      )}
      {openModalNotification && (
        <ModalReservationsNotifications
          onCancel={() => setOpenModalNotifications(false)}
          openModal={openModalNotification}
          backgroundVisible={false}
          defaultId={reservationSelected?.id}
        />
      )}
      {loading && <ModalLoading loading={loading} theme={theme} />}
      {selectedCheckInSendWpp?.id && (
        <ModalSendWpp
          onCancel={() => setSelectedCheckInSendWpp(null)}
          onSave={() => setSelectedCheckInSendWpp(null)}
          openModal={!!selectedCheckInSendWpp?.id}
          id={selectedCheckInSendWpp?.id as any}
        />
      )}
      {selectedCheckInSendEmail && (
        <ModalSendEmail
          onCancel={() => setSelectedCheckInSendEmail(null)}
          onSave={() => setSelectedCheckInSendEmail(null)}
          openModal={!!selectedCheckInSendEmail}
          id={selectedCheckInSendEmail.id as any}
        />
      )}
      {openModalExportGuests && (
        <ModalExportGuests
          onCancel={() => setOpenModalExportGuests(false)}
          openModal={openModalExportGuests}
          backgroundVisible={false}
        />
      )}
    </PageList>
  );
};
